import React, {Component} from "react"

export default class NavigationList extends Component {
  render() {
    return (
      <div
        className="sh-navigation-list"
        style={{
          display: "flex",
          flexFlow: "column",
          paddingBottom: 50,
          flex: 1
        }}
      >
        {React.Children.map(this.props.children, (node, index) => (
          <div className="item" key={index}>
            {node}
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/navigations/NavigationList.js